import { Button, message } from "antd";
import { useEffect, useState } from "react";
import StepCard from "../ui/StepCard";
import { Card, ListItem } from "./SectionTwo.default";
import CompletedStageCard from "../ui/CompletedStageCard";

// PD-02 §6.12 Implementation stage — rollout of company wellbeing actions,
// interventions, communications, program assignments and support measures.
const stageStepCards: Card[] = [
  {
    count: 1,
    status: "completed",
    title: "Assign approved interventions or programs",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Pick an approved wellbeing program from the available library and
          assign it to the right audience (company, department, vessel, group
          or named individuals).
        </li>
        <li>
          Set start / end dates and let the platform notify the audience.
        </li>
        <li>
          Monitor engagement and completion from the Actions and Analytics
          surfaces.
        </li>
      </>
    ),
    backgroundColor: "#d17f42",
    actions: [
      {
        name: "assign",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 2,
    status: "completed",
    title: "Create or assign company actions",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Create specific company actions aligned with the planning stage
          outputs (title, description, audience, start/expiry date, media).
        </li>
        <li>
          Delegate to owners and track completion in the Actions grid.
        </li>
      </>
    ),
    backgroundColor: "#8eb1bd",
    actions: [
      {
        name: "create",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 3,
    status: "completed",
    title: "Schedule training / events",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Create an event or training session with date, time, location (or
          online link), facilitator and audience.
        </li>
        <li>
          Attendance and completion feed back into company analytics.
        </li>
      </>
    ),
    backgroundColor: "#bdb0ac",
    actions: [
      {
        name: "schedule",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 4,
    status: "completed",
    title: "Send communications and assign resources",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Communicate updates and assign supporting resources (articles,
          videos, module packages) to the right audience.
        </li>
        <li>
          Monitor due dates and completion for every assigned item.
        </li>
      </>
    ),
    backgroundColor: "#7c9281",
    actions: [
      {
        name: "send",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
];

const completedStageList: ListItem[] = [
  {
    name: "Review Your Rollout:",
    items: [
      "Visit the Actions grid to confirm every assigned action, program and training is on track.",
      "Review the Communications sent and recipients covered.",
    ],
  },
  {
    name: "Submit the Implementation Stage:",
    items: [
      "Once rollout is confirmed, click the Submit Stage button.",
      "A confirmation popup will appear. Confirm to lock your inputs for this stage.",
    ],
  },
  {
    name: "Move to the Next Stage:",
    items: [
      "Upon submission, you'll be redirected to the Overview page where you can continue with the Evaluation stage.",
    ],
  },
];

const completedStageTitle = "Completing the Implementation Stage";

const subTitleText = (
  <p>
    Congratulations on completing Implementation! Follow these steps to
    finalize this stage:
  </p>
);

function SectionTwo() {
  const [submitActive, setSubmitActive] = useState(false);
  const [showCompletedStage, setShowCompletedStage] = useState(false);

  useEffect(() => {
    findUncompletedSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onSubmit() {
    setShowCompletedStage(true);
  }

  function findUncompletedSteps() {
    const uncompletedSteps = stageStepCards.filter(
      (step) => step.status !== "completed",
    );
    setSubmitActive(uncompletedSteps.length === 0);
    return uncompletedSteps;
  }

  return (
    <section className="mx-auto max-w-[1920px] px-16 py-16">
      {stageStepCards.map((card) => (
        <StepCard
          key={card.count}
          countValue={card.count}
          status={card.status}
          title={card.title}
          checkListTitle={card.listTitle}
          checkList={card.checkList}
          backgroundColor={card.backgroundColor}
          actions={card.actions}
        />
      ))}
      <div className="flex justify-center py-8">
        <Button
          disabled={!submitActive}
          className={`bg-[#ffc107] px-16 py-8 text-lg font-bold tracking-wide ${submitActive && "hover:text-white"} `}
          onClick={onSubmit}
        >
          SUBMIT
        </Button>
      </div>
      {(showCompletedStage || submitActive) && (
        <CompletedStageCard
          title={completedStageTitle}
          subTitleText={subTitleText}
          list={completedStageList}
        />
      )}
    </section>
  );
}

export default SectionTwo;
